import script from "./google-login.vue?vue&type=script&setup=true&lang=js"
export * from "./google-login.vue?vue&type=script&setup=true&lang=js"

import "./google-login.vue?vue&type=style&index=0&id=59e38742&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e38742"]])

export default __exports__